// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import NavBar from "./components/NavBar";
import router from "./router";
import VueWindowSize from "vue-window-size";
import VueScrollTo from "vue-scrollto";
import VueAxios from "vue-axios";
import Axios from "axios";

import { BootstrapVue, FormPlugin, LayoutPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import {
  FontAwesomeIcon,
  FontAwesomeLayers
} from "@fortawesome/vue-fontawesome";

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("font-awesome-layers", FontAwesomeLayers);

Vue.use(BootstrapVue);
Vue.use(FormPlugin);
Vue.use(LayoutPlugin);

Vue.config.productionTip = false;
Vue.use(VueWindowSize);
Vue.use(VueAxios, Axios);
Vue.use(VueScrollTo, {
  easing: "ease-in-out",
  offset: -50
});

Vue.prototype.$axios = Axios;
Vue.prototype.$auth = false;
Vue.prototype.$authToken = sessionStorage.getItem("authToken") || "";

let updateAxios = function() {
  let token = sessionStorage.getItem("authToken") || "";

  const instance = Axios.create({
    baseURL: "https://bobvlakefoundation.nl/api"
  });

  Vue.prototype.$authToken = token;

  if (token) {
    instance.defaults.headers.common["Authorization"] = "Bearer " + token;
  }

  Vue.prototype.$api = instance;

  Vue.prototype.$auth = token ? true : false;
};

updateAxios();

Vue.prototype.$updateAxios = updateAxios;

/* eslint-disable no-new */
let TheApp = new Vue({
  el: "#app",
  router,
  components: { App, NavBar },
  template: "<App/>"
});

window.TheApp = TheApp;



// WEBPACK FOOTER //
// ./src/main.js